import { render, staticRenderFns } from "./MovieModal.vue?vue&type=template&id=256b0dda&"
import script from "./MovieModal.vue?vue&type=script&lang=ts&"
export * from "./MovieModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports